import React, { Component } from 'react'
import Popover from 'material-ui/Popover'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import Chip from 'material-ui/Chip'
import { FormattedMessage } from 'react-intl'
import Modal from '../../../layouts/LoggedIn/Modal/Modal'
import { DropDownEmail, DropDownUserName, Footer } from './styles'
import images from '../../../config/images'
import { Link, Redirect } from 'react-router-dom'
import { checkAdminUrl, getImageURI, getToken, isAccountFree, isAccountPremium, isAccountStartter } from '../../../lib'
import config from '../../../config/config'

class ProfileDropDown extends Component {
  handleLogout = () => {
    const token = getToken()
    sessionStorage.removeItem('authToken')
    localStorage.removeItem('authToken')
    this.props.recieveLoginstatus(false, {})
    this.props.shouldRedirectUser(false)
    this.props.logoutUser(token)
  }

  render () {
    const {
      userid,
      popOverOpen,
      anchorEl,
      anchorOrigin,
      targetOrigin,
      onRequestClose,
      email,
      accountType,
      name,
      upgradeUser,
      newSeminarUpgradeModal,
      location
    } = this.props
    const imageURI = getImageURI(userid, images.profilePic)
    if (this.props.logoutSuccess) {
      return (
        <Redirect to={'/login'}/>
      )
    }
    return (
      <Popover
        open={popOverOpen}
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        targetOrigin={targetOrigin}
        onRequestClose={onRequestClose}
        useLayerForClickAway={false}
        zDepth={1}
        className='popover'
        style={{overflowY: 'none', border: 3}}>
        <div className='pa3 flex'>
          <div>
            <img
              style={{height: 100, width: 100, border: '1px solid #d9d9d9'}}
              src={imageURI}
              alt='profile'/>
          </div>
          <div className='pl3 flex justify-around flex-column'>
            <DropDownUserName>
              {name}
            </DropDownUserName>
            <DropDownEmail>
              {email}
            </DropDownEmail>
            <div>
              {false && <Chip
                backgroundColor={(isAccountFree(accountType)) ? '#4688F1' : (isAccountStartter(accountType)) ? '#FFC514' : '#C347E1'}>
                <div className='white ttu'>
                  {config.PLANS[accountType]}
                </div>
              </Chip>}
            </div>
          </div>
        </div>
        <div>
          <Footer className='pa3 flex justify-between'>
            {false &&
            <div>{(accountType !== 'admin' || accountType !== 'free_admin' && !isAccountStartter(accountType) && !isAccountPremium(accountType)) ? (
              <RaisedButton
                onTouchTap={(e) => {
                  e.preventDefault()
                  // onRequestClose();
                  // this.refs.modal.handleOpen();
                  // window.location = "https://webinar.freshvoice.net/"
                }}
                backgroundColor='#FCCE42'
                labelStyle={{color: '#8B7124'}}
                label={<FormattedMessage id='loggedInNavigation.upgrade'/>}/>
            ) : (!checkAdminUrl(this.props.location)) ? (
              <Link to={'/admin'}>
                {false && <FlatButton
                  label={<FormattedMessage id='loggedInNavigation.gotoAdmin'/>}
                  labelStyle={{color: '#AFB8C4'}}/>}
              </Link>
            ) : (
              <Link to={'/'}>
                {false && <FlatButton
                  label={<FormattedMessage id='loggedInNavigation.gotoGuest'/>}
                  labelStyle={{color: '#AFB8C4'}}/>}
              </Link>
            )} </div>}
            <FlatButton
              label={<FormattedMessage id='loggedInNavigation.logout'/>}
              onTouchTap={this.handleLogout}
              backgroundColor='#FFFFFF'
              labelStyle={{color: '#4688F1'}}/>
          </Footer>
        </div>
        <Modal
          user={{id: userid}}
          ref='modal'
          newSeminarUpgradeModal={newSeminarUpgradeModal}
          upgradeUser={upgradeUser}
          newSeminar={false}
          accountType={accountType}/>
      </Popover>
    )
  }
}

export default ProfileDropDown



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/ProfileDropDown.js